import styled from 'styled-components'
import { colors } from '../../../../../theme/theme';

export const Header = styled.div`
  height: 70px;
  background-color: ${colors.greyscale.black};
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  z-index: 9999;
`;

export const LogoBox = styled.div`
  @media (max-width: 900px) {
    width: 55%;
    text-align: end;
  }
`;

export const ProfileBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 75%;
`;

export const AvatarBox = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-evenly;
  margin-right: 20px;
  color: ${colors.greyscale.white};
  font-weight: bolder;
  cursor: pointer;
  border-radius: 7px;
  padding-left: 5px;
  padding-right: 5px;
  height: 100%;
  
  &.active {
    .sb-avatar__text{
      border: 2px solid ${colors.mainColors.verde_dstore} !important;
    }
    
  }

  @media (min-width:993px) and (max-width:1400px) {
    width: 100%;

    &:hover {
      background-color: ${colors.greyscale.semiblack}
    }
  }
`;